<template>
  <div>
    <component :is="currentPage"></component>
  </div>
</template>

<script>
import UserAgreementZHCN from './zh-CN/UserAgreement.vue';
import UserAgreementEN from './en/UserAgreement.vue';
import UserAgreementOverseasZHCN from './zh-CN/UserAgreementOverseas.vue';
import UserAgreementOverseasEN from './en/UserAgreementOverseas.vue';

export default {
  data() {
    return {
      currentPage: null,
    };
  },
  created() {
    const buildEnv = process.env.BUILD_ENV || '';
    const isOverseas = buildEnv.includes('overseas');
    const userLang = navigator.language || 'en';  // 获取浏览器的语言
    
    console.log('BUILD_ENV:', buildEnv, 'isOverseas:', isOverseas);
    
    if (isOverseas) {
      // overseas 环境加载 UserAgreementOverseas
      if (userLang.startsWith('zh')) {
        this.currentPage = UserAgreementOverseasZHCN;
      } else {
        this.currentPage = UserAgreementOverseasEN;
      }
    } else {
      // 非 overseas 环境加载普通版本
      if (userLang.startsWith('zh')) {
        this.currentPage = UserAgreementZHCN;
      } else {
        this.currentPage = UserAgreementEN;
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UserAgreement.vue